var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bnpl-topbar"},[_c('div',{staticClass:"topbar-actions"},[_c('button',{staticClass:"action-btn",attrs:{"title":"Atualizar"},on:{"click":function($event){return _vm.$emit('get-buy-now-pay-later')}}},[_c('b-icon',{attrs:{"icon":"sync-alt","size":"is-small"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }